import { Step1Setup } from "./Step1Setup";
import { Step2BackgroundParties } from "./Step2BackgroundParties";
import type { DraftFactConflict, DraftWizardData } from "@/types/drafting";

interface DraftWizardProps {
  data: DraftWizardData;
  conflicts: DraftFactConflict[];
  allPartiesConfirmed: boolean;
  currentStep: number;
  onChange: <K extends keyof DraftWizardData>(field: K, value: DraftWizardData[K]) => void;
  onExtractFromPaste: (text: string) => Promise<void>;
  onExtractFromFile: (text: string) => Promise<void>;
  onConfirmParties: () => Promise<void>;
  onResolveConflict: (conflictId: string, value: string) => Promise<void>;
  isExtracting?: boolean;
  isConfirming?: boolean;
  isResolvingConflict?: boolean;
}

export function DraftWizard({
  data,
  conflicts,
  allPartiesConfirmed,
  currentStep,
  onChange,
  onExtractFromPaste,
  onExtractFromFile,
  onConfirmParties,
  onResolveConflict,
  isExtracting = false,
  isConfirming = false,
  isResolvingConflict = false,
}: DraftWizardProps) {
  return (
    <div className="space-y-6">
      {currentStep === 1 ? (
        <Step1Setup data={data} onChange={onChange} />
      ) : (
        <Step2BackgroundParties
          data={data}
          conflicts={conflicts}
          allPartiesConfirmed={allPartiesConfirmed}
          onChange={onChange}
          onExtractFromPaste={onExtractFromPaste}
          onExtractFromFile={onExtractFromFile}
          onConfirmParties={onConfirmParties}
          onResolveConflict={onResolveConflict}
          isExtracting={isExtracting}
          isConfirming={isConfirming}
          isResolvingConflict={isResolvingConflict}
        />
      )}

      {currentStep === 2 && !allPartiesConfirmed ? (
        <p className="text-center text-xs text-[var(--lm-muted)] dark:text-slate-500">
          Confirm all parties before generating the draft.
        </p>
      ) : null}
    </div>
  );
}
